// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <sub-header header="'Edit hold'"></sub-header>

  <!-- Product information -->
  <div class="info info--deposit">
    <div class="info-detail">
      <span class="key">Product number:</span>
      <span class="value">{{\$ctrl.product.productNumber}}</span>
    </div>
    <div class="info-detail">
      <span class="key">Product status:</span>
      <span class="value">{{\$ctrl.product.status | prettyEnum}}</span>
    </div>
    <div class="info-detail">
      <span class="key">Available balance:</span>
      <span class="value">{{\$ctrl.product.balance | nxCurrency}}</span>
    </div>
    <div class="info-detail">
      <span class="key">Holds balance:</span>
      <span class="value">{{\$ctrl.product.holdsBalance | nxCurrency}}</span>
    </div>
  </div>

  <br/>

  <form name="\$ctrl.transactionForm">

    <table class="misc-transaction__table table table--generate-row-ids">
      <tbody>
      <tr>
        <td></td>
        <td>Hold type</td>
        <td>{{\$ctrl.hold.type | prettyEnum}} - {{\$ctrl.hold.subType | prettyEnum}}</td>
      </tr>
      <tr>
        <td></td>
        <td>Current amount</td>
        <td>{{\$ctrl.hold.amount | nxCurrency}}</td>
      </tr>
      <tr>
        <td></td>
        <td>New amount</td>
        <td>
          <cash ng-model="\$ctrl.amount"
            ng-required="true"
            max="\$ctrl.maxAmount"></cash>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Remarks</td>
        <td>
          <input
            required
            type="text"
            minlength="1"
            maxlength="128"
            ng-model="\$ctrl.updateRemarks"/>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="buttons">
      <button
        class="btn btn-warning"
        ng-click="\$ctrl.redirectBack()">
        Cancel
      </button>
      <button
        class="btn btn-success"
        command-access="UpdateManualHold"
        ng-click="\$ctrl.save()"
        ng-disabled="\$ctrl.transactionForm.\$invalid">
        Save
      </button>
    </div>

  </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/edit-hold/edit-product-hold.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;